import React, { Component } from 'react';
import Reorder from 'react-reorder';
import { Row, Col, Button, Card, Input, Alert, Popconfirm, message, Tag, Icon } from 'antd';
import './index.css';

import AddLeafPageModal from './modals/add-leaf-page';
import { _postDeleteLeafPage, _postUpdateLeafPage } from '../../services/index';

class Leaf extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modalVisible: false,
    }

    this.onModalVisible = this.onModalVisible.bind(this);
  }

  render() {

    return (
      <div>
        <Row type="flex">
          <Alert
            message="Proceed with Caution!"
            description="Any activation changes will be reflected on eezee.sg instantly! (Just reload the page if you aren't confident)"
            type="warning"          
            showIcon
            style={{ width: '100%' }}
          />
        </Row>
        <Row type="flex">
        <Card
          style={{ width: '100%', marginTop: 15 }}
          title={(
            <div style={{ width: '100%' }}>
              <Row type="flex" align="middle">
                <Col span={2}>
                  <span style={{ fontSize: 24 }}>Leaf Pages</span>
                </Col>
                <Col span={3}>
                  <Button 
                  onClick={() => this.onModalVisible()}
                  icon="plus"
                  style={{ marginLeft: 30 }}
                >
                  Add Page
                </Button>
                </Col>
              </Row>
            </div>
          )}
        >
          <Row type="flex" align="middle" className="table-header">
            <Col span={3}>
              <span>Image</span>
            </Col>
            <Col span={10}>
              <span>Title</span>
            </Col>
            <Col span={3}>
              <span>Status</span>
            </Col>
            <Col span={4}>
              <span>Groups</span>
            </Col>
            <Col span={4}>
              <span>Actions</span>
            </Col>
            
          </Row>

          <Reorder
            reorderId="leaf-page-list"
            reorderGroup="leaf-page"
            component="div"
            draggedClassName="dragged-list-item"
            lock="horizontal"
            holdTime={200}
            onReorder={this.props.onReorderLeaf}
            disabled={false}
          >
            {this.props.list.map(( item, index ) => (

              <Row key={index} type="flex" align="middle" className="leaf-page-item">
                <Col span={3}>
                  <img src={item.imageURL} alt="Leaf Page" height={80}/>
                </Col>
                <Col span={10}>
                  <span>{item.leafName}</span>
                </Col>
                <Col span={3}>
                  {item.active ? <Tag color="green">Active</Tag> : <Tag color="red">Deactive</Tag>}
                </Col>
                <Col span={4}>
                  <span>{item.groups.length}</span>
                </Col>
                <Col span={4}>
                  <Input.Group compact>
                    <Button onClick={() => this.props.onLeafEdit(index)} >
                      <span style={{ fontSize: 14 }} >Edit</span>
                    </Button>
                    <Popconfirm 
                      title="Delete this Leaf Page?"
                      okText="No"
                      cancelText="Delete"
                      onCancel={() => this.onDeleteLeafPage(index)}
                    >
                      <Button type="danger">
                        <span style={{ fontSize: 14 }} >Delete</span>
                      </Button>
                    </Popconfirm>
                    <Popconfirm
                      title={item.active ? "Deactivate Leaf Page?" : "Activate Leaf Page?"}
                      okText="No"
                      cancelText="Yes"
                      onCancel={() => this.onActivationClick(item)}
                    >
                      <Button type="primary">
                        {item.active ? <span>Deactivate</span> : <span>Activate</span>}
                      </Button>
                    </Popconfirm>
                  </Input.Group>
                </Col>
                
              </Row>

            ))}
          </Reorder>
          
          

        </Card>
        </Row>


        <AddLeafPageModal 
          modalVisible={this.state.modalVisible} 
          onModalVisible={this.onModalVisible}
          updateData={this.props.updateData}
          position={this.props.list.length}
        />

      </div>
    );
  }

  onDeleteLeafPage = (index) => {

    if (this.props.list[index].groups.length === 0) {
      let leafId = this.props.list[index]._id;

      console.log(this.props.list);

      _postDeleteLeafPage( leafId )
        .then(res => {
          console.log(res.data);
          this.props.updateData();
        })
        .catch(err => console.error(err))
    } else {
      message.warning("There are still existing groups in this Leaf Page!", 3);
    }
  }

  onModalVisible () {
    this.setState(prevState => ({
      modalVisible: !prevState.modalVisible
    }))
  }

  countWords () {
    let desc = this.state.newDesc;
    return desc.split(/\W+/).length;
  }


  onActivationClick = (leafPage) => {

    let groupActivations = false;

    leafPage.groups.map( group => {
      if (group.active) {
        groupActivations = true;
      }

      return group;
    });

    if (leafPage.groups.length > 0) {
      if (leafPage.leafName.length > 0 && leafPage.description.length > 0) {
        if (groupActivations) {
          let newLeafPage = leafPage;
  
          newLeafPage.active = !leafPage.active;
  
          _postUpdateLeafPage( newLeafPage )
            .then(res => {
              this.props.updateData();
              message.success('Leaf Page status switched!');
            })
            .catch(err => console.error(err));
        } else {
          message.error('Make sure at least one Group is Active before activating this Leaf Page.')
        }
      } else {
        message.error('Make sure name and description are filled in!')
      }
    } else {
      message.error('Make sure at least one Group exists!')
    }
  }
}

export default Leaf;


// WEBPACK FOOTER //
// ./src/components/leaf-page/leaf-page.js